import { BusinessProfile } from "./BusinessProfile";

export enum FundingRequestTypeEnum {
	Capital = 1,
	PurchaseOrder = 2,
	Assets = 3
}

export interface FundingRequest {
	Id: number;
	FundingTypeId: number;
	BusinessProfileId: number;
	BusinessProfile: BusinessProfile;
	IdNumber: string;
	AlternateContactNumber: string;
	EstimatedRevenue: string;
	Ammount: number;
	Term: string;
	AdditionalInformation: string;
	DateUpdatedUtc: string;
	CreatedByUserId: string;
	CreatedByUser: string;
	DateCreatedUtc: string;
	Approved: boolean;
	ApprovedByUserId: string;
	ApprovedDateUtc: string;
	Feedback: string;
	InReview: boolean;
}

export interface FundingCapitalOrAssetReques extends FundingRequest {
	Clients: string;
	DebtorsBookSize: string;
	PointOfSale: boolean;
	CardMachineMakeId: number;
	CardMachineMake: string;
	CardMachineTurnover: string;
	EftTurnover: string;
}

export interface FundingInvoiceRequest extends FundingRequest {
	Purpose: string;
	OrganizationType: string;
	Organization: string;
	PreviouslyWorked: boolean;
	ContactNumber: string;
	DateIssued: string;
	DateDue: string;
	PoAmmount: number;
	FinanceAmmount: number;
	PoNumber: string;
	Suplier: string;
}

export class FundingDocument {
	Id: string;
	Name: string;
}

export class CreateFundingRequestModel {
	id: number;
	fundingTypeId: FundingRequestTypeEnum;
	idNumber: string;
	alternateContactNumber: string;
	businessProfileId: number;
	estimatedRevenue: string;
	amount: number;
	term: string;
	additionalInformation: string;
	documents: FundingDocument[];
	inReview: boolean;
	feedback: string;
	createdByUser: string;
	constructor() {
        this.documents = [];
    }
}

export class EditFundingRequestModel extends CreateFundingRequestModel {
	id: number;
	constructor(item?: FundingRequest) {
		super();
		this.id = item && item.Id;
		this.fundingTypeId = item && item.FundingTypeId;
		this.idNumber = item && item.IdNumber;
		this.alternateContactNumber = item && item.AlternateContactNumber;
		this.businessProfileId = item && item.BusinessProfileId;
		this.estimatedRevenue = item && item.EstimatedRevenue;
		this.amount = item && item.Ammount;
		this.term = item && item.Term;
		this.additionalInformation = item && item.AdditionalInformation;
		this.inReview = item && item.InReview;
		this.feedback = item && item.Feedback;
		this.createdByUser = item && item.CreatedByUser;
	}
}





// WEBPACK FOOTER //
// ./src/app/models/inModels/FundingRequest.ts